import React, { Fragment, useMemo } from "react";
import { components } from 'common';
import { classSet } from "@umu/umu-dom";
import { IProps } from '../../theme/interface/common';
import { defaultThemeInfo, getTranslateThemeInfo, convertImage2PngFormat, getDefaultScaleInfo } from '../../theme/dataflow/index';
import { CERTIFICATE_IMG_TYPE } from '../../theme/interface/index';
import { defaultTheme } from '../../theme/images/index';
import { ThemeBasicInfo } from '../themeBasicInfo';

const { UMUBg } = components;
const CertificateTheme = (props: IProps) => {

    const {
        heardText = '',
        isShowMask,
        customMask,
        className = 'certificate-custom-theme-info',
        isShowCertificateInfo = false,
        enterpriseCertificateInfo,
        enterpriseExpendData,
        scaleRatio = 1,
        style: stylePre,
        ...rest
    } = props;
    const newThemeInfo = isShowCertificateInfo
        ? getTranslateThemeInfo(enterpriseCertificateInfo, enterpriseExpendData)
        : props.themeInfo || defaultThemeInfo;
    const [defaultCertificateWidth, defaultCertificateHeight, isHorizontal, isVertical] = getDefaultScaleInfo(newThemeInfo.displayStyle);

    const {
        certificateImg,
        certificateType,
        isCustomWidth = false,
        certificateContentStyle: style,
        certificateWidth = defaultCertificateWidth,
        certificateHeight = defaultCertificateHeight,
    } = newThemeInfo;
    const scaleX = Number((certificateWidth / defaultCertificateWidth).toFixed(2));
    const scaleY = Number((certificateHeight / defaultCertificateHeight).toFixed(2));
    let styleCss: React.CSSProperties = {};
    let stylePreCss: React.CSSProperties = {...stylePre};
    if (isCustomWidth) {
        styleCss = {
            width: defaultCertificateWidth ,
            height: defaultCertificateHeight,
            transform: `scale(${scaleX}, ${scaleY})`,
            position: 'absolute',
            transformOrigin: 'left top',
        };
        stylePreCss = {
            ...stylePre,
            width: defaultCertificateWidth * scaleX,
            height: defaultCertificateHeight * scaleX,
        }
    }

    const renderCertificateImg = useMemo(() => {
        const isImgSrc = certificateType === CERTIFICATE_IMG_TYPE.IMG_TYPE && typeof certificateImg === 'string'
        return isImgSrc ? (
            <UMUBg
                clsName="certificate-theme-img"
                bgSrc={convertImage2PngFormat(certificateImg) || defaultTheme.redThemeImg}
            />
        ) : (
            certificateImg
        );
    }, [certificateImg]);
    const renderMask = () => {
        return isShowMask ? (
            <div className={classSet({
                "certificate-theme-mask": true,
                "certificate-theme-mask-horizontal": isHorizontal,
                "certificate-theme-mask-vertical": isVertical,
            })} style={{ ...style, ...styleCss }}>
                {customMask}
            </div>
        ) : null;
    };
    return (
        <Fragment>
            {heardText}
            <div className={classSet({
                "certificate-theme-info": true,
                [className]: !!className,
                "certificate-theme-info-horizontal": isHorizontal,
                "certificate-theme-info-vertical": isVertical,
            })} style={stylePreCss} {...rest}>

                <div className={classSet({
                    "certificate-info": true,
                    "certificate-info-horizontal": isHorizontal,
                    "certificate-info-vertical": isVertical,
                })} style={{ ...style, ...styleCss }}>
                    {renderCertificateImg}
                    <ThemeBasicInfo {...props} />
                </div>
                {renderMask()}
            </div>
        </Fragment>
    );
};

export {
    CertificateTheme
}
